import React, { createContext, useContext } from 'react';

const SessionIdContext = createContext<string | null>(null);

export function SessionIdProvider(props: { sessionId: string | null; children: React.ReactNode }) {
    return <SessionIdContext.Provider value={props.sessionId}>{props.children}</SessionIdContext.Provider>;
}

export function useSessionId(): string | null {
    return useContext(SessionIdContext);
}

export function SessionId() {
    const sessionId = useSessionId();
    if (!sessionId) {
        return null;
    }
    return (
        <script
            dangerouslySetInnerHTML={{
                __html: 'window.__SESSION_ID=' + JSON.stringify(sessionId) + ';'
            }}
        />
    );
}
